import type { HTMLAttributes, MouseEventHandler, ReactNode } from 'react';

export interface MtCardItemLitterData {
  image?: string | null;
  breed?: string | null;
  price?: string;
  futureLitter?: {
    year: string;
    month: string;
  };
  waiting?: boolean;
  archived?: boolean;
  footer: ReactNode;
  onClick?: MouseEventHandler;
}

export interface MtCardItemLitterProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'onClick'>,
    MtCardItemLitterData {}
